import React from 'react';
import { motion } from 'framer-motion';
export const TrustSection = () => {
  const brands = ['Psychology Today', 'Wired', 'TechCrunch', 'The Verge', 'Vice'];
  return <section className="py-12 border-y border-gray-900 bg-[#050505] relative overflow-hidden" data-id="element-3313">
      <div className="max-w-6xl mx-auto px-6 relative z-10" data-id="element-3314">
        <p className="text-center text-gray-600 text-xs font-mono uppercase tracking-[0.2em] mb-8" data-id="element-3315">
          Trusted By Forensic Analysts & Therapists
        </p>

        <div className="flex flex-wrap justify-center items-center gap-8 md:gap-16 opacity-50 grayscale hover:grayscale-0 transition-all duration-500" data-id="element-3316">
          {brands.map((brand, index) => <motion.div key={brand} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className="text-xl md:text-2xl font-black text-gray-500 hover:text-white transition-colors uppercase tracking-tighter" data-id="element-3317">
              {brand}
            </motion.div>)}
        </div>
      </div>
    </section>;
};